(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakeWorkersCompensationComponent', psychIntakeWorkersCompensationComponent);

    psychIntakeWorkersCompensationComponent.$inject = [];

    function psychIntakeWorkersCompensationComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakeWorkersCompensationController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/workers-compensation.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakeWorkersCompensationController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakeWorkersCompensationController($scope, $stateParams, $element) {
        var vm = this;
        
        vm.datePickerOpenStatus = {
            dateOfInjury: false,
            lastDayWorked: false
        };

        vm.datePickerOptions = {
            maxDate: new Date()
        };

        function init() {
        }

        init();
    }
})();
